import fetchAPI from '../../../utils/fetchApi';

export default async function createFavorite(itemId, xsrfToken) {
  try {
    return await fetchAPI({
      url: `/cp/api/favorite`,
      method: 'POST',
      payload: { itemId },
      xsrfToken,
    });
  } catch {
    return false;
  }
}
